export namespace Colors {
  const isDarkMode = typeof window !== "undefined" && window.matchMedia('(prefers-color-scheme: dark)').matches;
  const isLightMode = !isDarkMode;

  export namespace Base {
    export const black = '#444';
    export const white = '#fff';

    export const white1_5 = '#eee';

    export const black2 = '#666';
    export const white2 = '#ccc';

    export const lightBlack = '#999';
    export const lighterBlack = '#aaa';
    export const lightestBlack = '#bbb';

    export const whiteHover = '#f9f9f9';
    export const whiteActive = '#f1f1f1';

    export const blackHover = '#333';
    export const blackActive = '#222';

    export const lightGray = '#eeeeee';

    export const red = '#ef5350';
  }

  export namespace Text {
    export const base = isLightMode ? Base.black : Base.white;
    export const hover = isLightMode ? Base.blackHover : Base.whiteHover;
    export const active = isLightMode ? Base.blackActive : Base.whiteActive;

    export namespace Faint {
      export const base = isLightMode ? Base.black2 : Base.white2;
      export const hover = isLightMode ? Base.blackHover : Base.whiteHover;
      export const active = isLightMode ? Base.blackActive : Base.whiteActive;
    }

    export namespace Inverted {
      export const base = isDarkMode ? Base.black : Base.white;
      export const hover = isDarkMode ? Base.blackHover : Base.whiteHover;
      export const active = isDarkMode ? Base.blackActive : Base.whiteActive;
    }
  }

  export namespace Container {
    export const background = isLightMode ? Base.white : Base.black;
    export const border = isLightMode ? Base.black : Base.white;
    export const shadow = isLightMode ? Base.lightBlack : Base.lightBlack;
  }
}
